"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTcpaEnabled = exports.canBeSetAsPrimary = exports.phoneHasConfirmationFeature = exports.findAddedPhone = exports.findPhoneById = exports.isLastElement = exports.isTcpaChanged = void 0;
var utils_1 = require("../../common/utils/phones/utils");
function isTcpaChanged(currentCallPref, currentTextPref, newCallPref, newTextPref) {
    var isTcpaChanged = false;
    if (currentCallPref != newCallPref || currentTextPref != newTextPref) {
        isTcpaChanged = true;
    }
    return isTcpaChanged;
}
exports.isTcpaChanged = isTcpaChanged;
function isLastElement(arr, element) {
    var isLastElement = false;
    if (arr && arr.length - arr.indexOf(element) == 1) {
        isLastElement = true;
    }
    return isLastElement;
}
exports.isLastElement = isLastElement;
function findPhoneById(phoneId, phoneList) {
    var phone = phoneList && phoneList.find(function (phone) { return phone.id == phoneId; });
    return phone;
}
exports.findPhoneById = findPhoneById;
function findAddedPhone(newPhoneList, oldPhoneList) {
    var phone = newPhoneList &&
        newPhoneList.find(function (phone) { return isNewPhone(phone, oldPhoneList); });
    return phone;
}
exports.findAddedPhone = findAddedPhone;
function isNewPhone(inputPhone, phoneList) {
    var isNewPhone = true;
    phoneList &&
        phoneList.map(function (phone) {
            if (phone.id == inputPhone.id) {
                isNewPhone = false;
            }
        });
    return isNewPhone;
}
function phoneHasConfirmationFeature(phoneType, isMobileCowConfirmable) {
    var hasConfirmFeature = false;
    if (phoneType === "MOBILE" && isMobileCowConfirmable) {
        hasConfirmFeature = true;
    }
    return hasConfirmFeature;
}
exports.phoneHasConfirmationFeature = phoneHasConfirmationFeature;
function canBeSetAsPrimary(phone) {
    var canBePrimary = false, phoneNotConfirmable = !phoneHasConfirmationFeature(phone.type, phone.isMobileCowConfirmable);
    if (phone.type === "MOBILE" && (phone.confirmed || phoneNotConfirmable)) {
        canBePrimary = true;
    }
    else if (phone.type === "WORK" || phone.type === "HOME") {
        canBePrimary = true;
    }
    return canBePrimary;
}
exports.canBeSetAsPrimary = canBeSetAsPrimary;
function isTcpaEnabled(phone, props) {
    var isTcpaEnabled = false, isSCAEnable = utils_1.isSCAEnabled(props.features);
    if (isSCAEnable) {
        isTcpaEnabled = phone.region
            ? phone.region === "US"
            : phone.phoneCodeCountries &&
                phone.phoneCodeCountries.includes("US");
    }
    else {
        isTcpaEnabled = phone.accountCountryCode === "US";
    }
    return isTcpaEnabled;
}
exports.isTcpaEnabled = isTcpaEnabled;
